import { type FC } from 'react';
import { Box, Typography } from '@mui/material';

const GalleryHeader: FC = () => {
    return (
        <Box sx={{
            textAlign: 'center',
            mb: { xs: 4, sm: 5, md: 6 },
            px: { xs: 1, sm: 2 }
        }}>
            <Typography
                variant="h2"
                fontWeight={700}
                gutterBottom
                sx={{
                    color: 'primary.dark',
                    fontSize: { xs: '1.75rem', sm: '2rem', md: '2.25rem', lg: '2.5rem' },
                    mb: { xs: 2, md: 3 }
                }}
            >
                Nuestras Sedes
            </Typography>
            <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                    maxWidth: { xs: '100%', sm: 600, md: 700, lg: 800, xl: 900 },
                    mx: 'auto',
                    fontSize: { xs: '0.938rem', sm: '1rem', md: '1.063rem', lg: '1.063rem' },
                    lineHeight: { xs: 1.6, md: 1.7 },
                    px: { xs: 1, sm: 0 }
                }}
            >
                Contamos con 5 sedes estratégicamente ubicadas en Popayán, cada una diseñada para ofrecer
                la mejor experiencia educativa y adaptada a las necesidades de nuestros estudiantes en cada nivel.
            </Typography>
        </Box>
    );
};

export default GalleryHeader;
